<div class="clients-container">
    <div class="summary-section">
        <div class="summary-card">
            <span class="summary-label">{{ 'clients.registeredClients' | translate }}</span>
            <span class="summary-value">{{ registeredClientsCount() }}</span>
        </div>
        <div class="summary-card">
            <span class="summary-label">{{ 'clients.newsletterSubscribers' | translate }}</span>
            <span class="summary-value">{{ newsletterSubscribersCount() }}</span>
        </div>
    </div>

    <div class="year-navigation">
        <button class="year-nav-button" (click)="onPreviousYear()">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="year-label">{{ selectedYear() }}</span>
        <button class="year-nav-button" (click)="onNextYear()">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>

    <div class="stats-table-container">
        <table class="stats-table">
            <thead>
                <tr>
                    <th>{{ 'clients.table.month' | translate }}</th>
                    <th>{{ 'clients.table.registered' | translate }}</th>
                    <th>{{ 'clients.table.subscribers' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                @for (monthKey of monthKeys; track monthKey; let i = $index) {
                <tr [class.even-row]="i % 2 === 0">
                    <td>{{ 'common.datepicker.month.' + monthKey | translate }}</td>
                    <td>{{ getRegisteredForMonth(i + 1) }}</td>
                    <td>{{ getSubscribersForMonth(i + 1) }}</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>